// extracted by mini-css-extract-plugin
export default {"inner":"_37gmiVeWYLtKltG5jpa9Rx","clamp1":"PTukf68fMSbG_-Vr8vzgS","clamp2":"aHFC3ubGUgwEQuQeoUz26","editorStyles":"_22E0fmzBCYwR_Rl38htwjw","fade":"_1SspKtLOYbfAoQ-b4Tinkc"};